

let filterItemsDropDownItems = document.querySelectorAll("[filterDropDown]");

filterItemsDropDownItems.forEach((el) => {
  let accTrigger = el.querySelector(".filter_acc-trigger");
  let accBody = null;
  let accArrow = accTrigger.querySelector(".display-flex");

  if (el.querySelector("div.filter_price") !== null) {
    accBody = el.querySelector(".filter_price");
  } else if (el.querySelector("div.filter_checkbox-wrap") !== null) {
    accBody = el.querySelector(".filter_checkbox-wrap");
  }

  if (accBody) {
    accBody.style.display = "none";

    let filterAccOpenTl = gsap.timeline({ paused: true });
    filterAccOpenTl
      .set(
        accBody,
        {
          display: "flex",
        },
        "<"
      )
      .to(
        accArrow,
        {
          rotate: 180,
          duration: 0.125,
          ease: "power3.inOut",
        },
        "<"
      );

    let filterOpenState = false;

    accTrigger.addEventListener("click", () => {
      if (filterOpenState == false) {
        filterAccOpenTl.play();
        filterOpenState = true;
      } else {
        filterAccOpenTl.reverse();
        filterOpenState = false; // Reset filterOpenState
      }
    });
  }
});

// openMarketFilter

let MarketFilterComp = document.querySelector(".market_filter-comp");
let MarketFilterbackground = MarketFilterComp.querySelector(
  ".market_filter-background"
);
let MarketFiltermodal = MarketFilterComp.querySelector(".market_filter");
let MarketFilteropenButton = document.querySelector(
  ".button.is--market-filter"
);

let MarketFiltertl = gsap.timeline({ paused: true });

mm.add("(max-width: 991px)", () => {
  MarketFiltertl.set(MarketFilterComp, {
    display: "flex",
  })
    .set("body", {
      overflow: "hidden",
    })
    .from(MarketFiltermodal, {
      x: "-30%",
      duration: 0.125,
      ease: "power1.out",
    })
    .from(
      MarketFilterbackground,
      {
        backgroundColor: "rgba(0, 0, 0, 0)",
        duration: 0.125,
        ease: "power1.out",
      },
      "<"
    );
});

MarketFilteropenButton.addEventListener("click", () => {
  MarketFiltertl.play();
});

MarketFilterbackground.addEventListener("click", () => {
  MarketFiltertl.reverse();
});

// layout button


function quanityButton() {
  // Select all the wrappers
  const wrappers = document.querySelectorAll(".m-product_q-wrap");

  // Iterate over each wrapper
  wrappers.forEach(function (wrapper) {
    // Select the increment and decrement buttons within the current wrapper
    const decrementButton = wrapper.querySelector(".amount-button.is--deq");
    const incrementButton = wrapper.querySelector(".amount-button.is--inc");

    // Select the input field within the current wrapper
    const quantityInput = wrapper.querySelector(".amount_amount");

    // Add event listener for decrement button
    decrementButton.addEventListener("click", function () {
      // Get the current value of the input field
      let currentValue = parseInt(quantityInput.value);

      // If the current value is greater than the minimum value, decrease it by 1
      if (currentValue > parseInt(quantityInput.min)) {
        quantityInput.value = currentValue - 1;
      }
    });

    // Add event listener for increment button
    incrementButton.addEventListener("click", function () {
      // Get the current value of the input field
      let currentValue = parseInt(quantityInput.value);

      // Increase the value by 1
      quantityInput.value = currentValue + 1;
    });
  });
}

document
  .getElementById("filterForm")
  .addEventListener("input", function (event) {
    document.querySelector(".market_products-grid").style.opacity = "60%";
    document.querySelector(".market_products-grid").style.pointerEvents =
      "none";

    let filterForm = document.getElementById("filterForm");
    let formData = new FormData(filterForm);
    let query = new URLSearchParams(formData).toString();

    let currentUrl = window.location.href.split("?")[0];
    let newUrl = `${currentUrl}?${query}`;

    fetch(newUrl)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newFilterTop = doc.querySelector(".filter_top");
        const currentFilterTop = document.querySelector(".filter_top");
        if (newFilterTop && currentFilterTop) {
          currentFilterTop.innerHTML = newFilterTop.innerHTML;
        }

        const newProducts = doc.querySelector(".market_products");

        const currentProducts = document.querySelector(".market_products");
        if (newProducts && currentProducts) {
          currentProducts.innerHTML = newProducts.innerHTML;
        }

        disableFilters();
        history.replaceState(null, "", newUrl);
        addHoverCards();
        newMarketAjax();
        quanityButton();

        document.querySelector(".market_products-grid").style.opacity = "100%";
        document.querySelector(".market_products-grid").style.pointerEvents =
          "auto";
      })
      .catch((error) => {
        console.error("Error fetching filtered products:", error);
      });
  });

function disableFilters() {
  document.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
    if (input.disabled) {
      let formDisabledDiv = input
        .closest(".form_checkbox")
        .querySelector(".form_disabled");

      if (formDisabledDiv) {
        formDisabledDiv.style.display = "block";
      }
    }
  });
}

quanityButton();
